import { resource } from "@angular/core";
import { signalStore, withComputed, withMethods, withProps } from "@ngrx/signals";
import { StateService } from "../services/state.service";

export const RecentlyViewedStore = signalStore(
    { providedIn: "root" },
    withProps(() => ({
        _resource: resource({
            loader: () => StateService.getRecentlyViewedItems(),
        }),
    })),
    withComputed((store) => ({
        items: () => store._resource.value() ?? [],
    })),
    withMethods((store) => ({
        refresh: () => store._resource.reload(),
    })),
);
export type RecentlyViewedStore = InstanceType<typeof RecentlyViewedStore>;
